var utils = require('util');
var EventEmitter = require('events').EventEmitter;

var View = module.exports = function() {
    this.initView();
};

utils.inherits(View, EventEmitter);

View.prototype.initView = function() {
    this.setMaxListeners(0);
};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/View.js